import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import ConfirmationModal from '../confirmation-modal/confirmation-modal.vue';
import { Subscription } from 'rxjs';
import BPCGenericApiResponse from '@core/interfaces/bpc-generic-api-response';

library.add(faPlus);

@Component({
  name: 'bpc-entity-delete-modal-provider',
  components: {
    'bpc-confirmation-modal': ConfirmationModal,
    'font-awesome-icon': FontAwesomeIcon,
  },
})
export default class EntityDeleteModalProvider extends Vue {
  @Prop(String) entity: string;

  entitySubscription: Subscription;

  loading = true;

  @Prop(String) readonly deletePath: string;
  @Prop(String) readonly hardDeletePath: string;
  @Prop(String) readonly recoverPath: string;
  @Prop(String) readonly bulkDeletePath: string;
  @Prop(String) readonly bulkHardDeletePath: string;
  @Prop(String) readonly bulkRecoverPath: string;
  @Prop(String) readonly mode: string;
  @Prop(String) readonly deleteMediaFilePath: string;

  get deleteEntityPath(): string {
    return this.deletePath ? this.deletePath : this.$bpcApiRouteHelper.getEntityPath(this.entity);
  }
  get hardDeleteEntityPath(): string {
    return this.hardDeletePath
      ? this.hardDeletePath
      : this.$bpcApiRouteHelper.getHardDeleteEntityPath(this.entity);
  }
  get recoverEntityPath(): string {
    return this.recoverPath
      ? this.recoverPath
      : this.$bpcApiRouteHelper.getRecoverEntityPath(this.entity);
  }
  get bulkDeleteEntityPath(): string {
    return this.bulkDeletePath
      ? this.bulkDeletePath
      : this.$bpcApiRouteHelper.getBulkDeleteEntityPath(this.entity);
  }
  get bulkHardDeleteEntityPath(): string {
    return this.bulkHardDeletePath
      ? this.bulkHardDeletePath
      : this.$bpcApiRouteHelper.getBulkHardDeleteEntityPath(this.entity);
  }
  get bulkRecoverEntityPath(): string {
    return this.bulkRecoverPath
      ? this.bulkRecoverPath
      : this.$bpcApiRouteHelper.getBulkRecoverEntityPath(this.entity);
  }

  deleteMediaFile($event): void {
    const deleteMedia = this.$store.dispatch('media/deleteMedia', {
      entity: this.entity,
      entityId: $event['entityIdOrIds']['entityId'],
      mediaId: $event['entityIdOrIds']['mediaId'],
    });

    deleteMedia.then(
      res => {
        if (res.data === true) {
          this.$emit('success-media-file-delete');
        }
      },
      error => {
        console.log('ERROR DELETE MEDIA FILE');
      },
    );
  }

  softDelete($event): void {
    this.loading = true;
    const entityId = $event['entityIdOrIds'];
    if (this.entitySubscription) {
      this.entitySubscription.unsubscribe();
    }
    let request = null;
    request = this.getBPCRequestService().post(this.deleteEntityPath + '/' + entityId, {
      ...$event,
      _method: 'delete',
    });
    this.entitySubscription = request.subscribe(
      (res: BPCGenericApiResponse) => {
        this.$emit('success-soft-delete');
      },
      error => {
        console.log(error);
      },
      () => {
        this.loading = false;
      },
    );
  }
  hardDelete($event): void {
    this.loading = true;
    const entityId = $event['entityIdOrIds'];
    if (this.entitySubscription) {
      this.entitySubscription.unsubscribe();
    }
    this.entitySubscription = this.$bpcApi
      .post(this.hardDeleteEntityPath + '/' + entityId, { ...$event, _method: 'delete' })
      .subscribe(
        // We add trash in query in order activate the trashed criteria
        (res: BPCGenericApiResponse) => {
          this.$emit('success-delete');
        },
        error => {
          console.log(error);
        },
        () => {
          this.loading = false;
        },
      );
  }
  recover($event): void {
    this.loading = true;
    const entityId = $event['entityIdOrIds'];
    if (this.entitySubscription) {
      this.entitySubscription.unsubscribe();
    }
    this.entitySubscription = this.$bpcApi
      .post(this.recoverEntityPath + '/' + entityId, $event)
      .subscribe(
        (res: BPCGenericApiResponse) => {
          this.$emit('success-recover');
        },
        error => {
          console.log(error);
        },
        () => {
          this.loading = false;
        },
      );
  }
  bulkSoftDelete($event): void {
    this.loading = true;
    const entityIds = $event['entityIdOrIds'];
    if (this.entitySubscription) {
      this.entitySubscription.unsubscribe();
    }
    this.entitySubscription = this.$bpcApi
      .post(this.bulkDeleteEntityPath, { ...$event, ids: entityIds })
      .subscribe(
        (res: BPCGenericApiResponse) => {
          this.$emit('success-bulk-soft-delete');
        },
        error => {
          console.log(error);
        },
        () => {
          this.loading = false;
        },
      );
  }
  bulkHardDelete($event): void {
    this.loading = true;
    const entityIds = $event['entityIdOrIds'];
    if (this.entitySubscription) {
      this.entitySubscription.unsubscribe();
    }
    this.entitySubscription = this.$bpcApi
      .post(this.bulkHardDeleteEntityPath, { ...$event, ids: entityIds })
      .subscribe(
        (res: BPCGenericApiResponse) => {
          this.$emit('success-bulk-delete');
        },
        error => {
          console.log(error);
        },
        () => {
          this.loading = false;
        },
      );
  }
  bulkRecover($event): void {
    this.loading = true;
    const entityIds = $event['entityIdOrIds'];
    if (this.entitySubscription) {
      this.entitySubscription.unsubscribe();
    }
    this.entitySubscription = this.$bpcApi
      .post(this.bulkRecoverEntityPath, { ...$event, ids: entityIds })
      .subscribe(
        (res: BPCGenericApiResponse) => {
          this.$emit('success-bulk-recover');
        },
        error => {
          console.log(error);
        },
        () => {
          this.loading = false;
        },
      );
  }
  private getBPCRequestService() {
    if (this.mode === 'storage') {
      return this.$bpcStorage;
    } else {
      return this.$bpcApi;
    }
  }
}
